"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keywordHtDefault = void 0;
var map_creator_1 = require("../../../base-utils/map-creator");
var destination_1 = require("../destination/base/destination");
var unicode_destination_1 = require("../destination/base/unicode-destination");
var color_table_destination_1 = require("../destination/color-table-destination");
var destination_revision_author_table_1 = require("../destination/destination-revision-author-table");
var font_table_destination_1 = require("../destination/font-table-destination");
var user_table_destination_1 = require("../destination/user-table-destination");
exports.keywordHtDefault = new map_creator_1.MapCreator()
    .add("bin", destination_1.DestinationBase.onBinKeyword)
    .add("colortbl", function (data) { return data.destination = new color_table_destination_1.ColorTableDestination(data); })
    .add("fonttbl", function (data) { return data.destination = new font_table_destination_1.FontTableDestination(data); })
    .add("protusertbl", function (data) { return data.destination = new user_table_destination_1.UserTableDestination(data); })
    .add("ansi", destination_1.DestinationBase.onAnsiKeyword)
    .add("mac", destination_1.DestinationBase.onMacKeyword)
    .add("pc", destination_1.DestinationBase.onPcKeyword)
    .add("pca", destination_1.DestinationBase.onPcaKeyword)
    .add("ansicpg", destination_1.DestinationBase.onAnsiCodePageKeyword)
    .add("hyphauto", destination_1.DestinationBase.onHyphAutoKeyword)
    .add("upr", function (data) { return data.destination = new unicode_destination_1.UnicodeDestination(data, data.destination); })
    .add("uc", destination_1.DestinationBase.onUnicodeCountKeyword)
    .add("revtbl", function (data) { return data.destination = new destination_revision_author_table_1.DestinationRevisionAuthorTable(data); })
    .add("u", destination_1.DestinationBase.onUnicodeKeyword)
    .get();
